import { observable, action } from 'mobx'
import _ from 'lodash'

import agent from '../../agent'
import BaseStore from '../BaseStore'

class LinkMessageStore extends BaseStore {
  @observable id = ''
  @observable placeholder = ''
  @observable link = ''
  @observable isDocument = ''

  constructor(args) {
    super()
    this.setup(args)
  }

  @action
  setup(args) {
    this.id = args.id
    this.placeholder = args.placeholder
    this.link = args.link
    this.isDocument = args.isDocument
  }

  @action
  async update(data) {
    const res = await agent.LinkMessage.update(data)
    this.setup(res.data.updateLinkMessageMutation.linkmessage)
    const ok = _.get(res, 'data.updateLinkMessageMutation.ok')
    if (!ok) throw Error('Link message not updated')
  }
}

export default LinkMessageStore
